import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <Header />
      <main className="not-found-card">
        <p className="not-found-code">404</p>
        <h1>{t('pageNotFound')}</h1>
        <p>{t('pageNotFoundDescription')}</p>
        <button type="button" onClick={() => navigate('/')}>{t('backHome')}</button>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
